import { __decorate, __param } from 'tslib';
import { Attribute, Inject, Input, HostBinding, Directive, NgModule } from '@angular/core';
import { TUI_IS_IOS } from '@taiga-ui/cdk/tokens';

/**
 * Abstraction over `inputMode` attribute
 */
import * as ɵngcc0 from '@angular/core';
let TuiInputModeDirective = class TuiInputModeDirective {
    constructor(pattern, isIOS) {
        this.pattern = pattern;
        this.isIOS = isIOS;
        this.mode = 'text';
    }
    get patternAttribute() {
        return this.mode === 'numeric' && this.isIOS && !this.pattern
            ? '[0-9]*'
            : this.pattern;
    }
};
TuiInputModeDirective.ɵfac = function TuiInputModeDirective_Factory(t) { return new (t || TuiInputModeDirective)(ɵngcc0.ɵɵinjectAttribute('pattern'), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS)); };
TuiInputModeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiInputModeDirective, selectors: [["input", "tuiInputMode", ""]], hostVars: 3, hostBindings: function TuiInputModeDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("inputmode", ctx.mode)("x-inputmode", ctx.mode)("pattern", ctx.patternAttribute);
    } }, inputs: { mode: ["tuiInputMode", "mode"] } });
TuiInputModeDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Attribute, args: ['pattern',] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] }
];
__decorate([
    Input('tuiInputMode'),
    HostBinding('attr.inputmode'),
    HostBinding('attr.x-inputmode')
], TuiInputModeDirective.prototype, "mode", void 0);
__decorate([
    HostBinding('attr.pattern')
], TuiInputModeDirective.prototype, "patternAttribute", null);
TuiInputModeDirective = __decorate([ __param(0, Attribute('pattern')),
    __param(1, Inject(TUI_IS_IOS))
], TuiInputModeDirective);

let TuiInputModeModule = class TuiInputModeModule {
};
TuiInputModeModule.ɵfac = function TuiInputModeModule_Factory(t) { return new (t || TuiInputModeModule)(); };
TuiInputModeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiInputModeModule });
TuiInputModeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputModeDirective, [{
        type: Directive,
        args: [{
                selector: 'input[tuiInputMode]'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['pattern']
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }]; }, { mode: [{
            type: Input,
            args: ['tuiInputMode']
        }, {
            type: HostBinding,
            args: ['attr.inputmode']
        }, {
            type: HostBinding,
            args: ['attr.x-inputmode']
        }], patternAttribute: [{
            type: HostBinding,
            args: ['attr.pattern']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputModeModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiInputModeDirective],
                exports: [TuiInputModeDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputModeModule, { declarations: [TuiInputModeDirective], exports: [TuiInputModeDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiInputModeDirective, TuiInputModeModule };

